import { apiClient } from "../../../config/axios.config";
import type { Response } from "../../../types/api.types";
import type { PurchaseConfirmResponse, PurchaseRequest } from "../dtos/request/purchase.request";
import type { PurchaseResponse } from "../dtos/response/purchase.response";

const model = 'v1/purchase';

export const postPurchase = async (request: PurchaseRequest): Promise<Response<PurchaseResponse>> => {
  const { data } = await apiClient.post(model, request);
  return data;
}

export const postPurchaseConfirm = async (request: PurchaseConfirmResponse): Promise<Response> => {
  const { data } = await apiClient.post(`${model}/confirm/${request.paymentKey}`, {}, { params: { orderId: request.orderId, amount: request.amount } });
  return data;
}